import React from 'react';
import {IntlProvider} from 'react-intl';
import messages from '../i18n';
import {connect} from 'react-redux';

const TranslationProvider = ({children, userLanguage}) => (
    <IntlProvider
        locale={userLanguage}
        messages={messages(userLanguage)}
        key={userLanguage}>
        {children}
    </IntlProvider>
);

const mapStateToProps = state => ({
    userLanguage: state.configuration.userLanguage,
});

export default connect(
    mapStateToProps,
    {},
)(TranslationProvider);
